import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class SoftwareDevelopment extends React.Component {
    render() {
      return (

      <div id='SoftwareDevelopment' style={{backgroundColor: '#050515'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Software Development</h2>
            <div> 
              <div className="float-left"> 
                <AnimateOnScroll direction="left" duration={600} delay={100}>
                  <img 
                    src={logo} 
                    style={{maxWidth:'400px',padding:"20px"}} 
                    alt="Bespoke software development for industrial control systems on Windows and Linux"
                    loading="lazy"
                  />
                </AnimateOnScroll>
              </div>
              <div style={{padding:"10px"}}> 
              <p>We specialise in developing software applications for both Windows and Linux platforms, and our experts have a wealth of experience in designing, building, and deploying customised software solutions.</p>
              <p>If you have legacy software this can also be upgraded and enhanced, ensuring it meets current industry requirements and the latest technologies. Additionally, we excel in taking charge of projects that may have been left unfinished, providing a dedicated approach to completion.</p>
              <p>We understand the unique challenges faced by industries such as manufacturing, consumer goods, healthcare and logistics. Our software solutions are designed to help our clients achieve their business goals while maintaining compliance with industry standards.</p>
              <p>Our team has a deep understanding of the latest technologies and trends in the industry, including machine learning, computer vision, and robotics.</p>
              </div>


    <p>
        These are some of our key focus areas:
    </p>

<div className="usp-list">
                    <div className="usp-item">
                        <strong>C# & .NET Ecosystem</strong>
                        <span>
                            Our primary stack for robust Windows-based industrial applications, 
                            utilising WPF, WinForms, and .NET Core to build high-performance 
                            interfaces.
                        </span>
                    </div>

                    <div className="usp-item">
                        <strong>C / C++ (Windows & Linux)</strong>
                        <span>
                            Used for performance-critical tasks, hardware abstraction layers, 
                            and cross-platform system development where deterministic 
                            execution and memory efficiency are paramount.
                        </span>
                    </div>

                    <div className="usp-item">
                        <strong>Python & Perl</strong>
                        <span>
                            Utilised for rapid prototyping, complex data manipulation, and 
                            the automation of industrial workflows. We specialise in Perl for 
                            legacy system maintenance and Python for modern AI/Vision integration.
                        </span>
                    </div>

                    <div className="usp-item">
                        <strong>Cross-Platform Development</strong>
                        <span>
                            Expertise in developing and deploying software across both 
                            Windows and Linux, ensuring your applications 
                            can run on everything from standard PCs to ruggedised industrial servers.
                        </span>
                    </div>

                    <div className="usp-item">
                        <strong>Reverse Engineering and Legacy Code Recovery</strong>
                        <span>
                            We specialise in the reverse engineering of legacy systems, 
                            analysing compiled DLLs and binary files to restore lost 
                            functionality or build modern wrappers for ageing hardware 
                            interoperability.
                        </span>
                    </div>
                </div>
     
     






           </div>
        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default SoftwareDevelopment;

